(function(konto) {
	konto.ek = {};
} (konto = window.konto));
